<template>
    <div class="signBox">
        <div class="imgBox">
            <div class="bannerBox">
                <div class="titleBox">
                    <img src="../assets/images/LOGOs.png" alt="" style="height:43px">
					<img src="../assets/images/h-logo2-icon.png" alt="" style="height: 29px;margin: 15px 0 0 30px;">
					<div class="titleline"></div>
                    <p>账号申诉</p>
                </div>
                <div class="whiteBox">
                    <div class="formBox">
                        <el-form :inline="true" :rules="rules" :model="forms" class="demo-form-inline h-formBorder h-formBorder-4" ref="forms">
                            <el-form-item label="公司名称" class="h-elformWrap-4" prop="username">
                                <el-input v-model="forms.username" placeholder="请输入公司全称"></el-input>
                            </el-form-item>
                            <el-form-item label="统一社会信用代码" class="h-elformWrap-4" prop="companycode">
                                <el-input v-model="forms.companycode" placeholder="统一社会信用代码"></el-input>
                            </el-form-item>
                            <el-form-item label="申诉类型" class="h-elformWrap-4"  prop="type" style="margin-bottom: 0.25rem;">
                                <el-select v-model="forms.type" placeholder="请选择">
                                    <el-option label="账号被冻结/禁用" value="0"></el-option>
                                    <el-option label="账号被删除" value="2"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="结果接收邮箱" class="h-elformWrap-4" prop="email">
                                <el-input v-model="forms.email" placeholder="请输入有效的邮箱地址"></el-input>
                            </el-form-item>
                            <el-form-item label="见证性资料" class="h-elformWrap-4" prop="upload" style="margin: 0.15rem 0 0.3rem 0;">
                                <el-upload
                                        v-model="forms.upload"
                                        ref="forms"
                                        class="upload-demo"
                                        action=""
                                        :http-request="httpRequest"
                                        :on-remove="handleRemove"
                                        :before-remove="beforeRemove"
                                        multiple
                                        :file-list="fileList"
                                        :auto-upload=true>
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                
                            </el-form-item>
							<!-- <div class="redText">
							    * 不可以上传、msi、exe,上传限制20M
							</div> -->
                            <el-form-item label="备注" class="h-elformWrap-4" >
                                <el-input :rows="3" resize="none" type="textarea" v-model="forms.tip" show-word-limit placeholder="请输入" maxlength="200"></el-input>
                            </el-form-item><!-- 
                            <div class="redText " style="margin-left:150px">
                                * 字数限制在200
                            </div> -->
                            <div class="dengluSign">
                                <div class="denglu" :class="{'active':index==indx}" v-for="(item,index) in list" :key="index" @click="login(index,'forms')">{{item}}</div>
                            </div>
                        </el-form>
                    </div>

                </div>
            </div>
            <div class="bottoms">
                Copyright Haier 2019. All rights reserved
            </div>
        </div>
    </div>
</template>
<script>
    import update from "../api/process/account_complaintService";
    import uploadFile from "../api/process/account_complainUploadService";
export default {
    data(){
        var validateCompanyCode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入统一社会信用代码'));
            } else {

                update.check(value).then(res => {
                    if (!res) {
                        callback(new Error('您的统一社会信用代码不正确'));
                    }else{
                        callback();
                    }
                });
            }
        };

        return{
           
            fileList: [],
            reftype:'账号申诉-见证性资料',
            forms:{
                username:'',
                companycode:'',
                type:'',
                upload:null,
                email:'',
                tip:''
            },
            updateStatus:{
                companycode:'',
                status:'',
                email:''
            },
            rules:{
                username: [
                    { required: true, message: "请输入公司全称", trigger: "blur" },
                ],
                companycode: [
                    { required: true, validator: validateCompanyCode, trigger: 'blur' },
                ],
                type: [
                    { required: true, message: '请选择申诉类型', trigger: 'blur' },
                ],
                upload: [
                    { required: true, message: '请上传见证性资料,不可以上传、msi、exe,上传限制20M', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入有效的邮箱地址', trigger: 'blur' },
                ]
            },
            list:["取消","提交"],
            indx:1
        }
    },
    methods:{
        httpRequest(params){
            // console.log(params,"1111111111")
            const loading = this.$msg.loading("上传中...");
            uploadFile.upload(params.file, {companycode: this.forms.companycode, reftype: this.reftype}).then(rd => {
                console.log("上传完毕后",rd);
                loading.close();
                this.fileList.unshift(rd.obj);
                this.forms.upload += this.forms.upload;
            }).catch(error=>{
                loading.close();
                this.fileList.splice(0,1);
                return Promise.reject(error);
            });
            return false;
        },
        beforeRemove(file) {
            return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				});
        },
        handleRemove(file) {
            // console.log(file, "aaaaa",fileList,"shanchu");
        //删除文件
            var id = file.id;
            uploadFile.deleteById(id).then(response => {
                // console.log(response,"删除")
            })
            //删除fileList数据
            // console.log(this.fileList);
            for (var i=0;i<this.fileList.length;i++){
                if (this.fileList[i].id === id){
                    this.fileList.splice(i,1);
                    // console.log(this.fileList)
                }
            }
        },
        login(index,formName){
            console.log(formName,"aaaaaaaaaaa")
            // this.$router.go(-1)
            //点击的是提交按钮
            if (index === 1){
				var flag = true;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log(valid)
                    } else {
						flag = false;
                        return false;
                    }
                });
				if(flag){
					// console.log(this.forms);
					this.updateStatus.companycode = this.forms.companycode;
					this.updateStatus.email = this.forms.email;
					this.updateStatus.status = this.forms.type;
					// console.log(this.updateStatus)
					update.updateData(this.updateStatus).then(response => {
					    // console.log(response)
					    if (response.f) {
					        ({
					            type: "success",
					            message: response.msg
					        });
					        this.$router.push({path: '/login'})
					    } else {
					        ({
					            type: "error",
					            message: response.msg
					        });
					    }
					})
				}
				

            }else{
                // this.$refs[formName].validate((valid) => {
                //     if (valid) {
                //         console.log('chenggong')
                //     }else{
                //         console.log('false')
                //         return false;
                //     }
                // });
                //点击的是取消按钮
                // console.log("222")
                this.$router.push({path: '/login'})
            }
        },
    }
}
</script>
<style scoped>
.redText{
    font-size: 14px;
    color: #e60012;
}
.imgBox{
    width: 100%;
    height: 695px;
    background: url(../assets/images/signBJ.jpg) center/cover;
}
.bannerBox{
    width: 990px;
    margin: 0 auto;
}
.titleBox{
    padding-top: 84px;
    display: flex;
}
.titleBox p{
    font-size: 26px;
    color: #ffffff;
    padding: 0;
    margin: 0;
    line-height: 50px;
    margin-left: 15px;
	margin-top: 3px;
}
.whiteBox{
    width: 100%;
    margin-top: 30px;
    padding: 50px 44px;
    background-color: #ffffff;
	border-radius: 8px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.07);
    margin-bottom: 73px;
}
.bottoms{
	position: fixed;
	bottom: 0;
	left: 0;
    background: #000;
    width: 100%;
    height: 53px;
    text-align: center;
    line-height: 53px;
    font-size: 14px;
    color: #a4a4a4;
}
.formBox{
    margin: 0 auto;
    width: 81%;
}
.dengluSign{
    margin-top: 52px;
    display: flex;
    justify-content: center;
}
.dengluSign .denglu{
    width: 28%;
	height: 50px;
	background-color: #ffffff;
    border: solid 1px #cccccc;
	border-radius: 4px;
    line-height:  48px;
    text-align: center;
    cursor: pointer;
    color: #787878;
    font-size: 20px;
    margin-left: 5%;
}
.dengluSign .denglu:first-child{
    margin-left: 0;
}
.dengluSign .denglu.active{
    border: solid 1px #128bf1;
    background-color: #128bf1;
    color: #fff;
}
.titleline{
	height: 28px;
	width: 3px;
	background: #fff;
	margin-top: 15px;
	margin-left: 15px;
}
/*  分辨率适配  */
@media screen and (max-width: 1610px){
	.dengluSign .denglu {
		width: 20%;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
	}
}
@media screen and (min-width: 1620px) and (max-width: 5000px){ 
	.dengluSign .denglu {
		width: 25%;
		height: 45px;
		line-height: 45px;
		font-size: 18px;
	}
}
</style>
<style>
.el-upload-list__item .el-icon-close-tip{
    right:60px;
}
.h-formBorder-4 .h-elformWrap-4{
    width: 100%;
}
.h-formBorder-4 .h-elformWrap-4 .el-form-item__label{
    width: 25%;
}
.h-formBorder-4 .h-elformWrap-4 .el-form-item__content{
    width: 75%;
}
.h-formBorder-4 .h-elformWrap-4 .el-form-item__content .el-input .el-input__inner{
    height: 50px;
}
.h-formBorder-4 .h-elformWrap-4 .el-form-item__content .el-select{
    width: 100%;
}
.h-formBorder-4 .h-elformWrap-4 .el-form-item__content .el-select .el-input__inner{
    width: 100%;
}

.h-formBorder-4 .h-elformWrap-4 .el-form-item__content .el-button--default{
    width: 100%;
    height: 50px;
    text-align: left;
    color: #b6b6b6;
    padding-left: 0.12rem;
}
.h-formBorder-4 .h-elformWrap-4 .el-form-item__content .el-button--primary{
    height: 40px;
}
.whiteBox .h-formBorder .el-form-item{
    margin-bottom: 0.15rem;
}

</style>